import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Image from '../Image';

function Archive({page_title}) {

    useEffect(() => {
            document.title = page_title;
    }, [page_title]);


    const [issues, setIssues] = useState([]);

    const [articles, setArticles] = useState([]);


    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllIssues')
          .then(res => res.json())
          .then(data => {
            if (data.success) {


                const publishedIssues = data.issues
                      .filter(issue => issue.publish === 1)

                setIssues(publishedIssues);
            }
          })
          .catch(err => console.error('Failed to fetch issues:', err));
      }, []);

    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=getAllArticles')
          .then(res => res.json())
          .then(data => {
            if (data.success) {
              setArticles(data.articles);
            }
          })
          .catch(err => console.error('Failed to fetch issues:', err));
      }, []);


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month.toUpperCase()} ${year}`;
    };


    const openIssuePdf = (file, e) => {
        e.stopPropagation();
        e.preventDefault();

        if (file) {
            window.open(file, '_blank');
        }
    };

    return (
      <>
        <div className='instructions_section'>
            <div className="instructions_wrapper">
                <h2 className='instructions_title'>
                   Archive
                </h2>

                <hr className="instructions_hr"/>

                <div className='archive_statistics_data'>
                    <div className='archive_statistics_data_wrap'>
                        <span className='archive_statistics_data_title'>Number of issues : <strong>{issues.length}</strong></span><span className='arch_line'>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span><span className='archive_statistics_data_title'>Number of articles : <strong>{articles.length}</strong></span>
                    </div>
                
                    <Link to="/articles" className='ann_link ann_link_arch'>
                        All Articles&nbsp;&nbsp;<span className="fa-solid fa-angle-right"></span>
                    </Link>
                
                </div>

                <div className='archive_issues_wrapper'>
                    {issues.map((issue) => (
                        <div className='homeiss_cover' key={issue.id}>
                        <div className='homeiss_image_block'>
                            <Link className='hao_link' to={`/articles?issue=${issue.id}`}>
                            <Image src={issue.image} alt="Annals of Nursing Cover" class="homeiss_image" />
                            </Link>
                        </div>
                        <div className="homeiss_data">
                            <p className='homeiss_date_arch'>
                            {formatDate(issue.date)}
                            </p>
                            <p className='homeiss_volno_arch'>
                            {issue.title}
                            </p>
                        </div>

                        <div className="homeiss_cta_wrapper">
                            <div 
                              className='sarticle_pdf_button_issue' 
                              onClick={(e) => openIssuePdf(issue.pdf, e)}
                            >
                              <span className="fa-solid fa-file-pdf"></span>
                              &nbsp;
                              Download Issue PDF

                          </div>
                        </div>

                        </div>
                    ))}
                </div>

            </div>
        </div>
      </>
    );
}

export default Archive;